var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _c("configs-popup-edit-info", { ref: "configs-popup-edit-info" }),
      _c("popup-edit-version", { ref: "popup-edit-version" }),
      _c("c-edit-audience-popup", { ref: "c-edit-audience-popup" }),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c("c-release-table", {
            staticStyle: { width: "100%" },
            on: {
              "show-configs-popup-edit-info": _vm.showEditInfoPopup,
              "show-popup-edit-version": _vm.showEditVersionPopup,
              "show-c-edit-audience-popup": _vm.showEditAudiencesPopup,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }